import "virtual:uno.css";
import "./base.css";
import { render } from "solid-js/web";
import { App } from "./App";
import { installViewport } from "./viewport";

const root = document.getElementById("app");
if (!root) throw new Error("#app missing");
root.textContent = ""; // drop the boot spinner from index.html
installViewport();
render(() => <App />, root);
